export default __webpack_public_path__ + "static/media/clock.0b591887.svg";